export default {"src":"/_next/static/media/beesIcon.081114b1.svg","height":19,"width":15,"blurWidth":0,"blurHeight":0};